const railsEnv = document.querySelector('meta[name="rails-env"]').content

if (railsEnv === 'production') {
  import('@sentry/browser').then(Sentry => Sentry.init({ 
    dsn: "https://f3ca0277b4ccef8451959d4b76f3a4fd@o4509228771508224.ingest.de.sentry.io/4509228777537616"
  }))
}
